// @flow
import type {AjaxActionType} from 'constants/flow/flowTypes';
import {CATEGORY} from 'constants/actions';

import type {CategoryItemsCountType} from './categoryItemsCountType';

export const initialState = {
    filters: [],
    status: 'initial',
};

/**
 * Get current category count items
 *
 * @param {object} state Current state
 * @param {object} action Received action
 * @returns {{status: string}} Current category data
 */
export default function categoryItemsCount(
    state: CategoryItemsCountType = initialState,
    action: AjaxActionType,
): CategoryItemsCountType {
    switch (action.type) {
        case `${CATEGORY.GET_CATEGORY_ITEMS_COUNT}_FULFILLED`:
            return {
                filters: action.payload.data,
                status: 'fulfilled',
            };
        case `${CATEGORY.GET_CATEGORY_ITEMS_COUNT}_PENDING`:
            return {
                ...state,
                status: 'pending',
            };
        default:
            return state;
    }
}
